import type {AddExpedientNoteFormPayload} from "./add-expedient-note.schema";
import {AddExpedientNoteBody} from "@project/sdk/sales/zod";
import {addExpedientNote} from "@project/sdk/sales";
import {mutationOptions} from "@tanstack/react-query";
import {expedientKeys, expedientMutationKeys} from "../../../../../expedient-keys";

export function addExpedientNoteMutationOptions(id: string) {
  return mutationOptions({
    mutationKey: expedientMutationKeys.addExpedientNote,
    mutationFn: (payload: AddExpedientNoteFormPayload) =>
      addExpedientNote(id, AddExpedientNoteBody.parse(payload)),
    onSuccess: async (_result, _payload, _context, {client}) => {
      await client.invalidateQueries({queryKey: expedientKeys.detail(id)});
    },
  });
}
